import { grid1x0 } from '@ad-lucy/components/layout/Grid/definitions/grid1x0';
import type { Category, GridInterface, Page } from '@ad-lucy/context/adData';

export const mockCategoriesWithSubpages: Category[] = [
  {
    alias: null,
    id: '10000',
    name: 'Category One',
    indexPageId: '1',
    pageIds: ['1'],
    showon: [],
    sorting: 0,
  },
  {
    alias: null,
    id: '20000',
    name: 'Category Two',
    indexPageId: '2',
    pageIds: ['2'],
    showon: [],
    sorting: 1,
  },
  {
    alias: null,
    id: '30000',
    name: 'Category Three',
    indexPageId: '3',
    pageIds: ['3'],
    showon: [],
    sorting: 2,
  },
  {
    alias: null,
    id: '40000',
    name: 'Category Four',
    indexPageId: '4',
    pageIds: ['4'],
    showon: [],
    sorting: 3,
  },
  {
    alias: null,
    id: '50000',
    name: 'Category Five',
    indexPageId: '5',
    pageIds: ['5'],
    showon: [],
    sorting: 4,
  },
];

export const mockSubpagesForCategories: Page[] = [
  {
    id: '1',
    categoryId: '10000',
    name: 'Page 1',
    grid: grid1x0()[0] as GridInterface,
    meta: {
      duration: 0,
    },
    subId: 0,
    tiles: [{ id: 100, components: [] }],
    sorting: 0,
  },
  {
    id: '2',
    categoryId: '20000',
    name: 'Page 2',
    grid: grid1x0()[0] as GridInterface,
    meta: {
      duration: 0,
    },
    subId: 0,
    tiles: [{ id: 101, components: [] }],
    sorting: 0,
  },
  {
    id: '3',
    categoryId: '30000',
    name: 'Page 3',
    grid: grid1x0()[0] as GridInterface,
    meta: {
      duration: 0,
    },
    subId: 0,
    tiles: [{ id: 102, components: [] }],
    sorting: 0,
  },
  {
    id: '4',
    categoryId: '40000',
    name: 'Page 4',
    grid: grid1x0()[0] as GridInterface,
    meta: {
      duration: 0,
    },
    subId: 0,
    tiles: [{ id: 103, components: [] }],
    sorting: 0,
  },
  {
    id: '5',
    categoryId: '50000',
    name: 'Page 5',
    grid: grid1x0()[0] as GridInterface,
    meta: {
      duration: 0,
    },
    subId: 0,
    tiles: [{ id: 104, components: [] }],
    sorting: 0,
  },
  {
    id: '6',
    categoryId: '60000',
    name: 'Page 6',
    grid: grid1x0()[0] as GridInterface,
    meta: {
      duration: 0,
    },
    subId: 0,
    tiles: [{ id: 105, components: [] }],
    sorting: 0,
  },
];
export const mockCategories: Category[] = [
  {
    alias: null,
    id: '10000',
    indexPageId: '0',
    name: 'Category One',
    pageIds: [],
    showon: [],
    sorting: 0,
  },
  {
    alias: null,
    id: '20000',
    name: 'Category Two',
    indexPageId: '2',
    pageIds: [],
    showon: [],
    sorting: 1,
  },
  {
    alias: null,
    id: '30000',
    name: 'Category Three',
    indexPageId: '4',
    pageIds: [],
    showon: [],
    sorting: 2,
  },
  {
    alias: null,
    id: '40000',
    name: 'Category Four',
    indexPageId: '6',
    pageIds: [],
    showon: [],
    sorting: 3,
  },
  {
    alias: null,
    id: '50000',
    name: 'Category Five',
    indexPageId: '7',
    pageIds: [],
    showon: [],
    sorting: 4,
  },
];

export const mockPages: Page[] = [
  {
    grid: grid1x0()[0] as GridInterface,
    subId: 0,
    categoryId: '0',
    id: '1',
    name: 'page',
    sorting: 0,
    meta: {
      duration: 0,
    },
    tiles: [
      {
        id: 0,
        components: [
          {
            id: 'comp-1',
            tileId: 0,
            meta: {},
            name: 'comp-1',
            element: <span>Comp 1 in Tile 0</span>,
          },
          {
            id: 'comp-2',
            tileId: 0,
            meta: {},
            name: 'comp-2',
            element: <span>Comp 2 in Tile 0</span>,
          },
          {
            id: 'comp-3',
            tileId: 0,
            meta: {},
            name: 'comp-3',
            element: <span>Comp 3 in Tile 0</span>,
          },
        ],
      },
    ],
  },
];
